import api from './api';

export interface FileUploadResponse {
  success: boolean;
  url: string;
  filename: string;
}

export const uploadFile = async (file: File, onProgress?: (progress: number) => void): Promise<FileUploadResponse> => {
  try {
    console.log('Starting file upload:', {
      filename: file.name,
      size: file.size,
      type: file.type
    });

    const formData = new FormData();
    formData.append('video', file);

    const response = await api.post('/api/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      }
    });

    console.log('File upload successful:', {
      filename: response.data.filename,
      url: response.data.url
    });

    return response.data;
  } catch (error) {
    console.error('File upload failed:', error);
    throw new Error(error?.response?.data?.error || 'Failed to upload file');
  }
};

export const deleteFile = async (key: string): Promise<{ success: boolean, message: string }> => {
  try {
    console.log('Deleting file:', key);
    const response = await api.delete(`/api/media/delete/${key}`);

    console.log('File deletion successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('File deletion failed:', error);
    throw new Error(error?.response?.data?.error || 'Failed to delete file');
  }
};